export const uploadInput = state => state.bulkData.uploadInput;
export const uploadAdmins = state => state.bulkData.uploadAdmins;

